@let componentType = contentViewStore.componentType();

@if (contentViewStore.isOpen()) {
  <div
    (click)="close()"
    data-smrtnc-test="right-content-view-overlay--backdrop"
    class="right-content-view-overlay-backdrop"
  ></div>
  <aside
    class="right-content-view-overlay-panel"
    animate.enter="slide-in"
    animate.leave="slide-out"
  >
    <div class="fwe-d-flex fwe-justify-content-space-between fwe-mb-4 fwe-px-s fwe-py-m">
      @if (contentViewStore.title()) {
        <h3 class="fwe-m-0">{{ contentViewStore.title() | translate }}</h3>
      }
      <button
        (click)="close()"
        data-smrtnc-test="right-content-view-overlay--close"
        class="fwe-btn fwe-btn-link fwe-dark"
        type="button"
      >
        <i class="fwe-icon fwe-icon-menu-close"></i>
      </button>
    </div>
    <div class="right-content-view-overlay-content">
      @if (componentType) {
        <ng-container *ngComponentOutlet="componentType; inputs: contentViewStore.componentInputs()" />
      }
    </div>
  </aside>
}
